import { render, staticRenderFns } from "./contentCourseLectureExamTagLevelEdit.vue?vue&type=template&id=440b32f8&"
import script from "./contentCourseLectureExamTagLevelEdit.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureExamTagLevelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports